<template>
  <div>
    <!-- 코치 상세 페이지 -->
    <div class="wrap coach-view-wrap">
      <div class="top-header">
        <incBack></incBack>
        <h3>코치</h3>
      </div>
      <div class="body-wrap">
        <div class="coach-profile">
          <div class="clear w-90per mg-auto pb-10 pt-10">
            <div class="w-50per float-left info">
              <h1 style="overflow: hidden; white-space: nowrap; text-overflow: ellipsis; padding-bottom: 0.5rem">
                {{ coarch.coarchName }} <span>코치</span>
              </h1>
              <p>{{ coarch.coarOnelineIntroduction }}</p>
              <div class="profile-point clear">
                <img src="@/assets/img/message.svg" class="float-left" />
                <p class="float-left" @click="showMessage()">코치님과 대화하기</p>
              </div>
            </div>
            <div class="w-50per float-left">
              <div class="profile-img-div">
                <img :src="coarch.coarPic" class="w-100per profile-img" />
              </div>
            </div>
          </div>
        </div>
        <div class="coach-info w-90per mg-auto">
          <div>
            <div class="clear info-title" @click="toogleCareer()">
              <div class="w-50per float-left txt-left">
                <h1>경력</h1>
              </div>
              <div class="w-50per float-left txt-right">
                <img src="@/assets/img/arrow-down.png" v-if="!isCareer" />
                <img src="@/assets/img/arrow-down.png" style="transform: rotate(180deg); top: 30%" v-if="isCareer" />
              </div>
            </div>
            <p v-if="isCareer">
              {{ coarch.coarCareer }}
            </p>
          </div>

          <div class="mt-20">
            <div class="clear info-title" @click="toggleType()">
              <div class="w-50per float-left txt-left">
                <h1>코칭 분야</h1>
              </div>
              <div class="w-50per float-left txt-right">
                <img src="@/assets/img/arrow-down.png" v-if="!isType" />
                <img src="@/assets/img/arrow-down.png" style="transform: rotate(180deg); top: 30%" v-if="isType" />
              </div>
            </div>
            <p v-if="isType">
              {{ coarch.coarchingType }}
            </p>
          </div>

          <div class="introduction mt-20">
            <p>
              {{ coarch.coarIntroduction }}
            </p>
          </div>
        </div>

        <div class="bnb-btn">
          <button class="active" @click="next()">코치님과 코칭 예약하기</button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import incBack from "@/components/inc/inc_back.vue";
export default {
  name: "coach_view",
  props: {
    idx: {
      type: [Number, String],
      default: 0,
    },
    rebook: {
      type: [Number, String],
      default: 0,
    },
  },
  data: () => ({
    isCareer: false,
    isType: false,
    coarch: {
      coarPic: "https://kr.object.ncloudstorage.com/bnb-platform/resources/img/search.png",
      coarLevel: "멘토",
      username: "김테스트",
      coarOnelineIntroduction: "21212",
      coarCareer: "222",
      coarMainArea: "11",
      coarReflectionCount: "1",
    },
  }),
  components: { incBack },
  mounted() {
    this.getCoarch();
  },
  methods: {
    toggleType() {
      this.isType = !this.isType;
    },
    toogleCareer() {
      this.isCareer = !this.isCareer;
    },
    showMessage() {
      this.$router.push({ name: "message", params: { coarchIdx: Number(this.idx) } });
    },
    getCoarch() {
      let params = {
        coarIdx: this.idx,
      };
      this.axios
        .get("/front/user/recommendCoarch/detail", { params })
        .then((res) => {
          if (res.data.success) {
            this.coarch = res.data.contentinfo;
          }
        })
        .catch((err) => {
          console.log(err);
        });
    },
    next() {
      this.$router.push({ name: "reserve", params: { idx: this.idx, rebook: this.rebook } });
    },
  },
};
</script>
<style lang="scss" scoped>
.profile-img-div {
  float: right;
  width: 150px;
  height: 180px;
  overflow: hidden;
  .profile-img {
    display: block;
    margin: 0px auto;
    width: 100%;
    height: 100%;
  }
}
</style>
